// Per-locale `online:` frontmatter flags of the markdown pages, collected by
// md2html.sh. Pages not generated from markdown are always online.
import online from '@/assets/generated/online.json'

export default function isOnline(slug, locale) {
  return online[`${slug}.${locale === 'de' ? 'de' : 'en'}`] !== false
}
